export default function About() {
  return (
    <section className="bg-black border-t border-b border-yellow-600/20 py-16 sm:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-16">
            {/* Left column */}
            <div className="lg:col-span-2">
              <div className="text-yellow-600 text-xs tracking-[0.3em] font-light mb-4 sm:mb-8 uppercase">
                About Ark Capital™
              </div>
              <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6 sm:mb-8">
                INSTITUTIONAL INVESTMENT IN ESSENTIAL INFRASTRUCTURE
              </h2>
              <div className="w-32 h-1 bg-yellow-600"></div>
            </div>

            {/* Right column */}
            <div className="lg:col-span-3">
              <div className="text-white/80 text-sm sm:text-base font-light leading-relaxed space-y-4 sm:space-y-6 max-w-2xl">
                <p>
                  Ark Capital™ is a private investment and development company dedicated to identifying and executing high-value projects in infrastructure, industrial production, logistics, and global trade.
                </p>
                <p>
                  Our firm focuses on strategic investments that create long-term value while supporting essential industries that power global economies.
                </p>
                <p>
                  Through disciplined capital deployment and strong operational partnerships, Ark Capital™ develops and manages projects that generate sustainable growth and long-term returns.
                </p>
              </div>

              {/* Statistics bar */}
              <div className="grid grid-cols-3 gap-4 sm:gap-8 mt-10 sm:mt-16">
                <div className="border-t-2 border-yellow-600 pt-4 sm:pt-6">
                  <div className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">2024</div>
                  <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase">Since</div>
                </div>
                <div className="border-t-2 border-yellow-600 pt-4 sm:pt-6">
                  <div className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">$2.4B</div>
                  <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase">AUM</div>
                </div>
                <div className="border-t-2 border-yellow-600 pt-4 sm:pt-6">
                  <div className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">47</div>
                  <div className="text-yellow-600 text-xs tracking-[0.2em] uppercase">Active Projects</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
